export default __webpack_public_path__ + "static/F-Pak-Customise-Packaging-Mobile-c5617919acb14a4849e3b03050f875d6.jpg";